<tax-page-header titleText="kkm.sign.selected.tariff.title"></tax-page-header>

<div class="ui-kit-content-container">
  <div class="ui-kit-centering-string">
    <tax-icon name="info" class="info-icon"></tax-icon>
    <span data-qa="notice">{{ 'kkm.sign.selected.tariff.notice' | translate }}</span>
  </div>
  <tax-kkm-sign-pdf
    *ngIf="processForm$ | async as processForm"
    [kkmForm]="processForm"
    [link]="link"
  ></tax-kkm-sign-pdf>
</div>
